export default {
  change_requests: "Change Requests",
  identification: "Identification",
  issues: "Issues",
  subtitle: "Zone Overview",
  risk_factor: "Risk factor",
  tab_attached: "Attached",
  tab_layouts: "Layouts",
  tab_overview: "Overview",
  title: "Zones",
  work_orders: "Work Orders",
  zone_id: "Zone ID",
}
